"use client"

import { ValueOf } from "next/dist/shared/lib/constants"
import { useState } from "react"
import ReactDOM from "react-dom"
import { useEventCallback } from "src/hooks/useEventCallback"
import { Ccm19EmbeddingName } from "src/integrations/ccm19/embeddings"
import { useCcm19EmbeddingAccepted } from "src/integrations/ccm19/useConsented"
import { MissingConsentNotice } from "src/integrations/lib/MissingConsentNotice"
import { YouTubeImage } from "src/integrations/youtube/YouTubeImage"
import { YouTubePlayButton } from "./YouTubePlayButton"

/** https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md */
export const ytPreviewQualities = {
  sm: { width: 480, name: "hqdefault" },
  md: { width: 640, name: "sddefault" },
  lg: { width: 1280, name: "maxresdefault" },
} as const

export function buildYtPreviewUrl(videoId: string, quality: ValueOf<typeof ytPreviewQualities>) {
  return `https://i.ytimg.com/vi_webp/${videoId}/${quality.name}.webp`
}

export type YouTubeIframePreviewProps = {
  videoId: string
  videoTitle: string
  onClick: () => void
}

export const YouTubeIframePreview = ({ videoId, videoTitle, onClick }: YouTubeIframePreviewProps) => {
  const [hovered, setHovered] = useState(false)
  const consented = useCcm19EmbeddingAccepted(Ccm19EmbeddingName.YouTube)
  const onMouseEnter = useEventCallback(() => setHovered(true))

  if (consented && hovered) {
    ReactDOM.preconnect("https://www.youtube-nocookie.com")
    ReactDOM.preconnect("https://www.google.com")
    ReactDOM.preconnect("https://fonts.gstatic.com")
  }

  const playLabel = `Video abspielen: ${videoTitle}`

  return (
    <>
      <YouTubeImage videoId={videoId} videoTitle={videoTitle} />

      {consented ? (
        <YouTubePlayButton title={playLabel} onMouseEnter={onMouseEnter} onClick={onClick} />
      ) : (
        <MissingConsentNotice consentId={Ccm19EmbeddingName.YouTube} />
      )}
    </>
  )
}
